import {engineContext} from './context.js';

(function(g){'use strict';
const VERSION='0.1.0-alpha';
function clone(x){return x==null?x:JSON.parse(JSON.stringify(x));}
function need(name){const x=g[name];if(!x)throw Error(name+'_REQUIRED');return x;}
function create(opts={}){
  const adapter=opts.adapter||need('ZooInvestRevisionAwarePersistenceAdapter');
  const concurrency=opts.concurrency||need('ZooInvestResearchStateRevisionConcurrencyEngine');
  const baseRepo=need('ZooInvestResearchStateRepositoryEngine');
  const driver=opts.driver||baseRepo.makeMemoryDriver();

  function key(symbol,scope){return adapter.storageKey(symbol,scope);}

  async function load(symbol,scope='RESEARCH'){
    const k=key(symbol,scope);
    const raw=await driver.get(k);
    if(!raw)return Object.freeze({found:false,key:k,record:null});
    const migrated=adapter.migrate(raw);
    if(!migrated.migrated)return Object.freeze({found:true,key:k,record:null,error:migrated.reason});
    const valid=adapter.validateRecord(migrated.record);
    if(!valid.valid)return Object.freeze({found:true,key:k,record:null,error:'INVALID_RECORD',issues:valid.issues});
    return Object.freeze({found:true,key:k,record:Object.freeze(clone(migrated.record))});
  }

  async function save(input={},options={}){
    const symbol=input.symbol, scope=input.scope||'RESEARCH';
    const existing=await load(symbol,scope);
    if(existing.error)return Object.freeze({saved:false,error:existing.error,issues:existing.issues||[]});

    const expectedRevision=Number.isInteger(Number(options.expectedRevision))?Number(options.expectedRevision):0;
    const decision=concurrency.mergeDecision(existing.record,input,expectedRevision);
    if(!decision.allowed){
      return Object.freeze({
        saved:false,error:decision.reason,key:key(symbol,scope),
        actualRevision:decision.actualRevision??0,
        expectedRevision:decision.expectedRevision??expectedRevision
      });
    }

    const packed=adapter.pack({...input,revision:decision.nextRevision});
    const valid=adapter.validateRecord(packed);
    if(!valid.valid)return Object.freeze({saved:false,error:'INVALID_RECORD',issues:valid.issues});

    const k=key(symbol,scope);
    await driver.set(k,packed);
    return Object.freeze({saved:true,key:k,record:Object.freeze(clone(packed)),revision:packed.revision});
  }

  async function remove(symbol,scope='RESEARCH'){return Object.freeze({removed:await driver.remove(key(symbol,scope)),key:key(symbol,scope)});}

  return Object.freeze({VERSION,driverKind:driver.kind,key,load,save,remove});
}
async function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  const r=create();
  const miss=await r.load('AAA','OWNED');
  ok('empty repo',miss.found===false);
  const s1=await r.save({symbol:'AAA',scope:'OWNED',savedAt:'T1'},{expectedRevision:0});
  ok('create saved',s1.saved===true);
  ok('create revision one',s1.revision===1);
  const l1=await r.load('AAA','OWNED');
  ok('load revision one',l1.record.revision===1);
  const stale=await r.save({symbol:'AAA',scope:'OWNED',savedAt:'T2'},{expectedRevision:0});
  ok('stale write blocked',stale.saved===false&&stale.error==='REVISION_CONFLICT');
  const s2=await r.save({symbol:'AAA',scope:'OWNED',savedAt:'T2'},{expectedRevision:1});
  ok('matching update saved',s2.saved===true);
  ok('update revision two',s2.revision===2);
  const l2=await r.load('AAA','OWNED');
  ok('revision persisted through adapter',l2.record.revision===2);
  const rm=await r.remove('AAA','OWNED');
  ok('remove works',rm.removed===true);
  ok('no trade signal',!('tradeSignal'in r));
  ok('no capital permission',!('capitalPermission'in r));
  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}
g.ZooInvestRevisionAwareRepository=Object.freeze({VERSION,create,selfTest});
})(engineContext);